/**
 * Lesbare Fehlermeldung für den Zahlungsmethoden-Dialog.
 *
 * handleApiErrorGeneric ersetzt Backend-Antworten mit 400/500 durch die
 * Pauschalmeldung „Es ist ein interner Fehler aufgetreten …" und hängt die
 * eigentliche Ursache nur als `originalMessage` an. Im Pflicht-Dialog (keine
 * Zahlungsmethode) ist die Ursache entscheidend – ohne sie wusste der
 * Administrator nicht, warum das Zahlungsformular fehlt (Fehlermeldung
 * 16.10.2026, Autohaus Biberach). Abgelaufene Sitzung (401) und fehlende
 * Berechtigung (403) behalten ihre eigenen Texte.
 */
import { gt } from '@/i18n/gt'

export function paymentMethodErrorMessage (error: unknown, fallback: string): string {
  if (!error || typeof error !== 'object') return fallback
  const err = error as { message?: unknown, errorCode?: unknown, originalMessage?: unknown }
  const cause = typeof err.originalMessage === 'string' ? err.originalMessage.trim() : ''
  const keepOwnText = err.errorCode === 401 || err.errorCode === 403
  if (cause && !keepOwnText) return cause
  const message = typeof err.message === 'string' ? err.message.trim() : ''
  return message || fallback
}

/** Nutzlast von PaymentMethodDialog@close nach gescheitertem Formular-Aufbau. */
export interface PaymentMethodDismissDetail {
  failed?: boolean
  message?: string
}

/**
 * Hinweis am Onboarding-Schritt „Apps & Lizenzen", wenn der Administrator
 * den Pflicht-Dialog mit „Später erneut versuchen" verlassen hat: die
 * Ursache (falls bekannt) als eigener Satz, dann was er tun kann.
 */
export function paymentMethodDismissMessage (detail?: PaymentMethodDismissDetail): string {
  const hint = gt('Sie können die App-Auswahl anpassen oder es über „Übernehmen & weiter" erneut versuchen.')
  const cause = detail?.message?.trim() ?? ''
  if (!cause) return `${gt('Die Zahlungsmethode wurde noch nicht hinterlegt.')} ${hint}`
  const sentence = /[.!?]$/.test(cause) ? cause : `${cause}.`
  return `${sentence} ${hint}`
}
